import React from 'react';

type Props = {
  maxListPrice: number;
  minListPrice: number;
  maxOfferPrice: number;
  minOfferPrice: number;
  mapPriceIndicator: number;
  priceIndicator: number;
};

const ProductPrice = ({
  maxListPrice,
  minListPrice,
  maxOfferPrice,
  minOfferPrice,
  mapPriceIndicator,
  priceIndicator,
}: Props) => {
  // map price indicator is 1 "see price in cart"
  // price indicator is 0 was price
  // offer price (min and max)
  // list price (was price) or not on sale price (min and max)
  // const { details } = props;
  // const { price } = details;
  // const {
  //   mappriceindicator,
  //   priceindicator,
  //   maxlistprice,
  //   minlistprice,
  //   maxofferprice,
  //   minofferprice,
  // } = price;

  const seePriceInCart = mapPriceIndicator === 1;
  const isClearance = priceIndicator === 0;

  const renderListPrice = () => {
    if (!minListPrice || !maxListPrice) return null;
    return (
      <div className="was-price">
        <p
          className={`${
            minListPrice.toFixed(2).length >= 5 && maxListPrice !== minListPrice && 'was-price-font'
          }`}>
          {'Was: '}
          {`$${minListPrice.toFixed(2)}`}
          {maxListPrice !== minListPrice ? ` - $${maxListPrice.toFixed(2)}*` : '*'}
        </p>
      </div>
    );
  };

  const renderOfferPrice = () => {
    if (!minOfferPrice || !maxOfferPrice) return null;
    return (
      <div className={isClearance ? 'offer-price hmf-subheader-bold-s' : 'final-price'}>
        <p>
          {isClearance ? 'Now: ' : ''}
          {`$${minOfferPrice.toFixed(2)}`}
          {maxOfferPrice !== minOfferPrice ? ` - $${maxOfferPrice.toFixed(2)}` : ''}
        </p>
      </div>
    );
  };

  const renderSeeInCart = () => {
    return (
      <>
        <p className="final-price">See Price In Cart</p>
        {renderListPrice()}
      </>
    );
  };

  const renderPrice = () => {
    return (
      <>
        {renderOfferPrice()}
        {isClearance && renderListPrice()}
      </>
    );
  };

  return (
    <div className="dsg-search-price hmf-subheader-s">
      {seePriceInCart ? renderSeeInCart() : renderPrice()}
    </div>
  );
};

export default ProductPrice;
